import React from 'react';
import styled from 'styled-components';

const ToggleWrapper = styled.div`
  position: absolute;
  top: ${(p) => (p.pos?.bottom ? 'auto' : '6px')};
  bottom: ${(p) => (p.pos?.bottom ? p.pos?.bottom : 'auto')};

  right: ${(p) => (p.pos?.right ? p.pos?.right : '6px')};

  border-radius: 50px;
  background: #353cf7;
  background:${(p) => p?.is_custom ? p?.is_custom : 'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'} ;
  color: #fff;
  padding: 1px 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  z-index: 10;

  min-width: ${(props) => props?.isHomePage ? '35px' : '50px'};

  font-size: ${(props) => props?.isHomePage ? '10px' : '16px'};

  flex-direction: ${(p) => (p.orActive === 'OR' ? 'row' : 'row-reverse')};

  transition: flex-direction 0.9s ease-in;
  span {
    width:${(props) => props?.isHomePage ? '10px' : '16px'};
    height:${(props) => props?.isHomePage ? '10px' : '16px'};
    background: #fff;
    border-radius: 50px;
  }
`;

const Toggle = ({ pos, toggleValue, toggleIndividualGroup, toggleGroup,isHomePage ,is_custom}) => {
  return (
    <ToggleWrapper
      is_custom={is_custom}
      onClick={toggleIndividualGroup}
      orActive={toggleValue}
      pos={pos}
      isHomePage={isHomePage}
    >
      <span></span>
      <div>{toggleValue}</div>
    </ToggleWrapper>
  );
};

export default Toggle;
